import { _isStart, _isEnd, } from '../route-model/RoutePoint';
const _u_movePoint = ({ p: point, np: newLatLng, r: route, }) => {
    point.m().setLatLng(newLatLng);
    const isStart = _isStart(point), isEnd = _isEnd(point);
    let lengthChange = 0;
    if (isStart) {
        route.sv().setLatLng(newLatLng);
    }
    else {
        const incomingLine = point.il();
        if (incomingLine) {
            lengthChange += _changeLineLength(incomingLine, false, point);
        }
    }
    if (isEnd) {
        route.ev().setLatLng(newLatLng);
    }
    else {
        const outgoingLine = point.ol();
        if (outgoingLine) {
            lengthChange += _changeLineLength(outgoingLine, point, false);
        }
    }
    route.len().add(lengthChange);
}, _changeLineLength = (line, newStartPoint, newEndPoint) => {
    const oldLength = line.len();
    line.set(newStartPoint, newEndPoint);
    const newLength = line.len();
    return newLength - oldLength;
}, _u_movePointBack = ({ p: point, op: oldLatLng, r: route, }) => _u_movePoint({
    p: point,
    np: oldLatLng,
    r: route,
});
export { _u_movePoint, _u_movePointBack, };
